import script from "./LightBox.vue?vue&type=script&setup=true&lang=js"
export * from "./LightBox.vue?vue&type=script&setup=true&lang=js"

import "./LightBox.vue?vue&type=style&index=0&id=edb1a4be&lang=less&scoped=true"

import exportComponent from "M:\\Meshkat\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb1a4be"]])

export default __exports__